import { RefObject } from 'preact';
import { useEffect } from 'preact/hooks';

const useOutsideClick = (
  ref: RefObject<HTMLElement>,
  handler: (event: MouseEvent) => void,
  ignoreClick?: boolean
): void => {
  useEffect(() => {
    const cb = (event: MouseEvent): void => {
      if (
        !ref?.current ||
        ref?.current?.contains((event?.target as Node) || null) ||
        ignoreClick
      ) {
        return;
      }

      handler(event);
    };
    document.addEventListener('mousedown', cb);
    return (): void => {
      document.removeEventListener('mousedown', cb);
    };
  }, [ref, handler]);
};

export default useOutsideClick;
